<script setup lang="ts">
import type { ButtonShellProps } from '.';

const { theme = 'default' } = defineProps<ButtonShellProps>();
defineSlots<{ default: () => void; icon: () => void }>();
</script>

<template>
  <span
    :class="transition ? 'px-r8 py-r4' : 'py-r3 px-7'"
    class="group/button-shell relative isolate block rounded-[100px] select-none"
  >
    <span
      :class="[
        transition
          ? 'inset-1 size-[calc(100%-8px)] shadow-[0px_0px_0px_4px_rgba(248,101,47,0.6)] transition-[box-shadow,inset,width,height] group-active/button-shell:inset-0 group-active/button-shell:size-full group-active/button-shell:shadow-none'
          : 'top-0 left-0 size-full',
        {
          'bg-client-orange': theme === 'default',
          'bg-client-white': theme === 'white',
        },
      ]"
      class="absolute -z-1 rounded-[100px]"
    ></span>
    <AppText
      size="md"
      class="text-client-black gap-r4 inline-flex items-center font-medium"
    >
      <slot />
      <slot name="icon" />
    </AppText>
  </span>
</template>
